import { render, staticRenderFns } from "./RevokeDealer.vue?vue&type=template&id=c4f2f190&"
import script from "./RevokeDealer.vue?vue&type=script&lang=js&"
export * from "./RevokeDealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports